import { reportingService } from '@/common/reporting';
export const $pr = reportingService;
